import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrackingSttV2 = _resolveComponent("TrackingSttV2")!
  const _component_TrackingSttV1 = _resolveComponent("TrackingSttV1")!

  return (_ctx.isVersionNew)
    ? (_openBlock(), _createBlock(_component_TrackingSttV2, { key: 0 }))
    : (_openBlock(), _createBlock(_component_TrackingSttV1, { key: 1 }))
}